import { requestPost, requestGet } from 'utils/request';
import { handleErrors } from '@tcc/scarecrow';

let USER_BASE_URL = '/api/user';
let EULA_BASE_URL = '/api/eula';

export function createAccountRequest(
  email,
  firstName,
  lastName,
  password,
  phoneNumber,
  countryCode
) {

  return requestPost(`${USER_BASE_URL}/v2/register`, {
    data: JSON.stringify({
      firstName,
      lastName,
      email,
      'phone': phoneNumber,
      password,
      countryCode,
      'preferences': {}
    })
  }).
    then(handleErrors);
}

export function eulaRequest(countryId) {
  return requestGet(`${EULA_BASE_URL}/v1/documents/eula?countryCode=${countryId}`).
    then(handleErrors);
}

export function privacyPolicyRequest(countryId) {
  return requestGet(`${EULA_BASE_URL}/v1/documents/pp?countryCode=${countryId}`).
    then(handleErrors);
}

export function agreementDocumentRequest(userId, documentId) {
  return requestPost(`${EULA_BASE_URL}/v1/agreements`, {
    headers: {
      'x-user-id': userId
    },
    data: JSON.stringify({
      documentId,
      source: 'Climate Web'
    })
  });
}

export function locationRequest(coordinates) {
  const { latitude, longitude } = coordinates;
  const params = `latitude=${latitude}&longitude=${longitude}`;
  return requestGet(`/api/geopolitical/v1/reverseGeocode?${params}`).
    then(handleErrors);
}
